export const getTimeInSecs = (data) => {
    // Se data è già un numero, lo restituisce direttamente
    if (typeof data === 'number') {
        return data;
    }

    // Se non ci sono dati, ritorna 0
    if (!data) {
        return 0;
    }

    let total = 0;

    // Se data è una stringa che può essere convertita a numero
    if (typeof data === 'string') {
        const parsed = parseFloat(data);
        if (!isNaN(parsed)) {
            return parsed;
        }

        // Controlla se è nel formato MM:SS o HH:MM:SS
        if (data.includes(':')) {
            const parts = data.split(':').map(p => parseInt(p));
            if (parts.length === 2) { // MM:SS
                return parts[0] * 60 + parts[1];
            } else if (parts.length === 3) { // HH:MM:SS
                return parts[0] * 3600 + parts[1] * 60 + parts[2];
            }
        }
    }

    // Gestione per oggetto {minutes, seconds}
    if (typeof data === 'object') {
        // Verifica che seconds esista
        if (data.seconds !== undefined && data.seconds !== null) {
            const seconds = parseFloat(data.seconds);
            if (!isNaN(seconds)) {
                total += seconds;
            }
        }

        // Verifica che minutes esista
        if (data.minutes !== undefined && data.minutes !== null) {
            const minutes = parseFloat(data.minutes);
            if (!isNaN(minutes)) {
                total += minutes * 60;
            }
        }
    }

    return total;
};

export function convertiSecondiAMinuti(secondi) {
    // Garantisci che secondi sia un numero valido
    if (isNaN(secondi) || secondi === null || secondi === undefined) {
        return "0:00";
    }

    secondi = parseFloat(secondi);

    // Formato MM:SS per compatibilità con la visualizzazione nell'interfaccia
    const minuti = Math.floor(secondi / 60);
    const secondiRimanenti = Math.round(secondi % 60);

    // Gestione del caso in cui i secondi arrotondati siano 60
    if (secondiRimanenti === 60) {
        return `${minuti + 1}:00`;
    }

    // Formato MM:SS per coerenza con l'interfaccia
    const secondiFormattati = secondiRimanenti.toString().padStart(2, '0');
    return `${minuti}:${secondiFormattati}`;
}

export function getMinSecObject(secondi) {
    var minuti = Math.floor(secondi / 60); // Calcola il numero intero dei minuti
    var secondiRimanenti = secondi % 60; // Calcola i secondi rimanenti
    return { minutes: minuti, seconds: secondiRimanenti }; // Restituisce il valore numerico come float
}

export const getDurationFromSecond = (secs) => {
    const sec_num = parseInt(secs, 10);
    const hours = Math.floor(sec_num / 3600);
    const minutes = Math.floor(sec_num / 60) % 60;
    const seconds = sec_num % 60;
    return [hours, minutes, seconds]
        .map((v) => (v < 10 ? "0" + v : v))
        .filter((v, i) => (v !== "00" || i > 0) && !isNaN(v))
        .join(":");
};